import { Mui, MuiIcons } from "@osu/react-ui";
import { NavLink } from "react-router-dom";
import { mergeSxStyles } from "../../util/functions";


const CreateLinks = ({ paths = [], sx, ...rest }) => {
  if (!paths.length) {
    return false;
  }
  return paths.map(({ path, title }, index) => (
    <Mui.Button
      key={path + index}
      startIcon={<MuiIcons.Add titleAccess="Create" />}
      sx={mergeSxStyles({ mr: 1, mb: 1, textTransform: "none" }, sx)}
      variant="outlined"
      to={path}
      component={NavLink}
      {...rest}
    >
      {title}
    </Mui.Button>
  ));
};

export default CreateLinks;
